export default "__VITE_ASSET__BKBTg5Tc__"